<template>
  <div
    :style="pageYStyles"
    class="container-xxl nx-flights-section px-1"
    :class="`${flights.length > 0 ? 'has-data' : ''}`"
  >
    <div class="row g-1" v-if="flights.length > 0">
      <template v-for="(flight, flightIndex) in flights" :key="flightIndex">
        <div
          class="col-12"
          v-if="
            timeSheets.length > 1 &&
            (flightIndex == 0 ||
              flights[flightIndex - 1].timeSheetId != flight.timeSheetId)
          "
        >
          <div class="card bg-light text-muted">
            <span class="px-2">{{
              timeSheetById(flight.timeSheetId).title
            }}</span>
          </div>
        </div>
        <div class="col-12">
          <div
            class="card"
            :class="`${flightIndex % 2 == 0 ? 'bg-highlight' : ''}`"
          >
            <div class="card-body p-1">
              <div :class="`row g-1`" :ref="'nx-flight-' + flight.id">
                <div
                  :class="`col-12  ${
                    displayHoles(flight) && singleHoleMode === false
                      ? 'col-xl-3'
                      : 'col-xl-12'
                  }`"
                >
                  <div class="row g-1">
                    <div class="col-2 col-xl-2 text-center align-self-center">
                      <div class="row">
                        <div class="col-12">
                          <span
                            :class="`badge fs-6 text-dark rounded-3 bg-white border nx-flight-toggle`"
                            @click="toggleFlight(flight.id)"
                            >{{ flight.number }}</span
                          >
                        </div>
                        <div class="col-12 lh-1 pt-1">
                          {{ flight.timeFormatted }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-10"
                      :class="`${
                        displayHoles(flight) && singleHoleMode
                          ? 'col-sm-8'
                          : 'col-sm-10'
                      }`"
                    >
                      <players-list
                        :flight="flight"
                        :onClick="onPlayerClick"
                      ></players-list>
                    </div>
                    <div
                      v-if="displayHoles(flight) && singleHoleMode === true"
                      class="col-12 col-sm-2"
                    >
                      <holes-row-single-hole-mode
                        :flight="flight"
                        :flightIndex="flightIndex"
                        :onClick="onHoleClick"
                      ></holes-row-single-hole-mode>
                    </div>
                    <div
                      v-if="displayHoles(flight) && singleHoleMode === false"
                      class="col-12 d-sm-none"
                      :class="`${
                        openFlights?.includes(flight.id) ? 'd-none' : 'd-block'
                      }`"
                    >
                      <holes-row-compact
                        :flight="flight"
                        :flightIndex="flightIndex"
                        :onClick="onHoleClick"
                      ></holes-row-compact>
                    </div>
                  </div>
                </div>
                <div
                  class="col-12 col-xl-9 d-sm-block nx-flight-row align-self-center"
                  :class="`${
                    openFlights?.includes(flight.id) ? 'd-block' : 'd-none'
                  }`"
                  v-if="displayHoles(flight) && singleHoleMode === false"
                >
                  <holes-row-full
                    :flight="flight"
                    :flightIndex="flightIndex"
                    :onClick="onHoleClick"
                  ></holes-row-full>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="col-12 col-xl-6" v-if="$root.can('refereeDecisions:read')">
        <referee-decisions-section
          :timeSheets="timeSheets"
          :flights="flights"
        ></referee-decisions-section>
      </div>
      <div class="col-12 col-xl-6" v-if="$root.can('delays:read')">
        <delays-section
          :timeSheets="timeSheets"
          :onClick="onDelayClick"
          :onOpen="onDelayOpen"
        ></delays-section>
      </div>
    </div>
    <template v-else>
      <div
        class="d-flex align-items-center justify-content-center nx-empty-flights-message"
      >
        <div class="text-muted">
          {{ emptyFlightsMessage() }}
        </div>
      </div>
    </template>
    <nav-footer
      :onCurrentFlightClick="jumpToCurrentFlight"
      :hasFlights="flights.length !== 0"
    />
    <delay-modal ref="delayModal" :pageY="pageY" />
    <set-offset-modal ref="offsetModal" :pageY="pageY" />
    <set-player-state-modal ref="playerStateModal" :pageY="pageY" />
    <referee-decision-modal ref="refereeDecisionModal" :pageY="pageY" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import NavFooter from "../shared/nav_footer.vue";
import HolesRowCompact from "./components/holes_row_compact.vue";
import HolesRowSingleHoleMode from "./components/holes_row_single_hole_mode.vue";
import HolesRowFull from "./components/holes_row_full.vue";
import PlayersList from "./components/players_list.vue";
import DelayModal from "./components/delay_modal.vue";
import DelaysSection from "./components/delays_section.vue";
import RefereeDecisionModal from "./components/referee_decision_modal.vue";
import RefereeDecisionsSection from "./components/referee_decisions_section.vue";
import SetOffsetModal from "./components/set_offset_modal.vue";
import SetPlayerStateModal from "./components/set_player_state_modal.vue";
import { mapGetters } from "vuex";
import { useToast } from "vue-toastification";

export default defineComponent({
  props: {
    startHoleFilter: Number,
  },
  components: {
    NavFooter,
    HolesRowFull,
    HolesRowCompact,
    HolesRowSingleHoleMode,
    DelayModal,
    DelaysSection,
    SetOffsetModal,
    SetPlayerStateModal,
    RefereeDecisionModal,
    RefereeDecisionsSection,
    PlayersList,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    let openFlights;
    try {
      openFlights = JSON.parse(localStorage.getItem(`open_flights`)) ?? [];
    } catch (e) {
      openFlights = [];
    }
    return { pageY: null, openFlights };
  },
  methods: {
    emptyFlightsMessage() {
      if (this.timeSheets.length === 0) {
        return this.$t("message.noTimeSheet");
      }
      if (this.flights.length === 0) {
        return this.$t("message.noFlight");
      }
      return this.$t("message.noData");
    },
    toggleFlight(flightId) {
      if (this.openFlights?.includes(flightId)) {
        this.openFlights = this.openFlights?.filter((f) => f != flightId);
      } else {
        this.openFlights?.push(flightId);
      }
      localStorage.setItem(`open_flights`, JSON.stringify(this?.openFlights));
    },
    holeByFlightAndNumber(flight, number) {
      return flight?.holes?.find((h) => h.number === number);
    },
    finishedSelectedSingleHole(flight) {
      const hole = this.holeByFlightAndNumber(
        flight,
        this.selectedSingleHole ?? 1
      );
      if (hole) {
        return hole.targetTime < this.timestamp;
      }
      return false;
    },
    onDelayOpen(event) {
      this.$refs.delayModal.show();
      this.pageY = event.pageY;
    },
    onDelayClick(event, delay) {
      if (this.$root.can("delays:manage")) {
        this.$refs.delayModal.show(delay);
        this.pageY = event.pageY;
      }
    },
    onPlayerClick(event, flight, player) {
      if (this.$root.enablePlayerStateModal(flight)) {
        this.$refs.playerStateModal.show({
          player: player,
          timeSheetType: flight.timeSheetType,
          timeSheetId: flight.timeSheetId,
          flightId: flight.id,
        });
        this.pageY = event.pageY;
      }
    },
    onHoleClick(event, flight, flightIndex, hole) {
      if (this.$root.enableHoleSettingsModal()) {
        this.showSetOffsetDialog(flight, flightIndex, hole);
        this.pageY = event.pageY;
      }
    },
    showSetOffsetDialog(flight, flightIndex, hole) {
      let prevFlight;
      if (flightIndex != 0) {
        for (let index = 0; index <= flightIndex; index++) {
          const element = this.flights[flightIndex - index];
          if (
            element.startHole === flight.startHole &&
            element.id !== flight.id
          ) {
            prevFlight = element;
            break;
          }
        }
      }

      const flightOvertake = this.flightOvertakes.find(
        (fO) =>
          fO.sourceFlightId == flight.id &&
          fO.overtakingHoleNumber == hole.number
      );
      this.$refs.offsetModal.show({
        timeSheetId: flight.timeSheetId,
        flightNumber: flight.number,
        flightId: flight.id,
        prevFlight,
        holeNumber: hole.number,
        offset: hole.offset,
        flightOvertake,
        hole,
      });
    },
    timeSheetById(id) {
      return this.timeSheets.find((tS) => tS.id == id);
    },
    jumpToCurrentFlight() {
      let currentFlight = this.flights?.find(
        (f) => !this.finishedSelectedSingleHole(f)
      );
      if (typeof currentFlight === "undefined") {
        currentFlight = this.flights[0];
      }
      var element = this.$refs["nx-flight-" + currentFlight.id];
      var top = element[0].offsetTop;
      window.scrollTo(0, top - 230);
    },
    displayHoles(flight) {
      const nonMatchingTargetTimes = flight?.holes?.some(
        (h) => h?.targetTimeMillis !== flight?.timeMillis
      );

      return (
        flight?.holes?.length > 0 &&
        this.$root.can("holes:read") &&
        nonMatchingTargetTimes
      );
    },
  },
  computed: {
    ...mapGetters({
      timeSheets: "timeSheets/timeSheets",
      timestamp: "timeSheets/getTimestamp",
      startHole: "navigation/getStartHole",
      startHoleSort: "navigation/getStartHoleSort",
      flightTimeLimit: "navigation/getFlightTimeLimit",
      showHomeClub: "navigation/getShowHomeClub",
      singleHoleMode: "navigation/getSingleHoleMode",
      selectedSingleHole: "navigation/getSelectedSingleHole",
    }),
    flights() {
      const filteredFlights = [].concat(
        ...this.timeSheets?.map((timeSheet) => {
          let flights = timeSheet.flights;
          if (
            !isNaN(this.startHole) &&
            this.startHole != 0 &&
            this.startHole != null
          ) {
            flights = flights.filter(
              (flight) => flight.startHole == this.startHole
            );
          }
          if (
            !isNaN(this.flightTimeLimit) &&
            this.flightTimeLimit != 0 &&
            this.flightTimeLimit != null
          ) {
            const targetTimeLimit =
              this.timestamp - this.flightTimeLimit * 60000;
            flights = flights.filter((flight) => {
              if (flight.holes?.length > 0) {
                return flight.holes?.some(
                  (hole) => hole.targetTime > targetTimeLimit
                );
              }
              return flight.timeMillis > targetTimeLimit;
            });
          }
          if (this.startHoleSort) {
            return flights.slice().sort((a, b) => {
              if (this.startHoleSort === 1) return a.startHole - b.startHole;
              else return b.startHole - a.startHole;
            });
          }
          if (this.singleHoleMode) {
            return flights.slice().sort((a, b) => {
              const selectedHoleA = a.holes?.find(
                (h) => h.number === (this.selectedSingleHole ?? 1)
              );
              const selectedHoleB = b.holes?.find(
                (h) => h.number === (this.selectedSingleHole ?? 1)
              );
              return selectedHoleA?.targetTime - selectedHoleB?.targetTime;
            });
          }
          return flights;
        })
      );
      if (this.timeSheets?.length > 1) {
        filteredFlights.sort(function (o1, o2) {
          return o1.timeMillis - o2.timeMillis;
        });
      }
      return filteredFlights;
    },
    delays() {
      return [].concat(
        ...this.timeSheets?.map((timeSheet) => timeSheet.delays ?? [])
      );
    },
    refereeDecisions() {
      return [].concat(
        ...this.timeSheets?.map((timeSheet) => timeSheet.refereeDecisions ?? [])
      );
    },
    flightOvertakes() {
      return [].concat(
        ...this.timeSheets?.map((timeSheet) => timeSheet.flightOvertakes ?? [])
      );
    },
    pageYStyles() {
      return this.$route?.query?.iframe ? { paddingBottom: "500px" } : {};
    },
  },
});
</script>

<style lang="scss">
.bg-highlight {
  background-color: #eee !important;
}

.list-group-item.nx-player-list-item {
  &.mobile {
    font-size: 12px;
  }
  &.clickable:hover,
  &.clickable:hover span {
    background-color: #e2e2e2 !important;
    color: #000 !important;
    cursor: pointer;
  }
}

.list-group-item.list-group-item-action {
  &.clickable:hover {
    cursor: pointer;
  }
}

.nx-flight-toggle:hover {
  background-color: #e2e2e2 !important;
  color: #000 !important;
  cursor: pointer;
}

.nx-flights-section {
  &.has-data {
    padding-bottom: 5rem !important;
  }
}

.nx-empty-flights-message {
  height: calc(100vh / 2);
}
</style>
